import { FormDivider } from '@form/FormDivider';
import { StyledInput } from '@ui';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebouncedValue } from '../../../../hooks/useDebouncedValue';
import { PermissionInput } from './PermissionInput';

const PermissionInputList = ({ permissions }: { permissions: { [x: string]: any } }) => {
    const { t } = useTranslation('general');
    const [search, setSearch] = useState('');
    const debounceSearch = useDebouncedValue(search, 800);

    const resolvePermissionCategory = useCallback(
        (categoryName: string) => t(`permissions.categories.${categoryName}`, { defaultValue: categoryName }),
        [t]
    );

    const filteredPermissions = useMemo(
        () =>
            Object.entries(permissions).filter(([permissionGroupKey, permissionGroup]) =>
                permissionGroup.some(
                    ([, label]) =>
                        label.includes(debounceSearch) ||
                        resolvePermissionCategory(permissionGroupKey).includes(debounceSearch)
                )
            ),
        [permissions, debounceSearch, resolvePermissionCategory]
    );
    return (
        <>
            <StyledInput
                clearable
                aria-label={t('permissions.common.search')}
                fullWidth
                css={{ mb: '$12' }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t('permissions.common.search')}
            />
            {filteredPermissions.map(([permissionGroupKey, permissionGroup]) => (
                <React.Fragment key={permissionGroupKey}>
                    <FormDivider title={resolvePermissionCategory(permissionGroupKey)} noSpacer />
                    <div className="tw-my-4 tw-grid tw-grid-cols-[auto_auto_1fr] tw-gap-x-4">
                        <label className="tw-justify-self-center tw-text-sm tw-text-accents-6">{t('permissions.common.allow')}</label>
                        <label className="tw-justify-self-center tw-text-sm tw-text-accents-6">{t('permissions.common.deny')}</label>
                        <label className="tw-justify-self-center tw-text-sm tw-text-accents-6">{t('permissions.list.function')}</label>
                        {permissionGroup.map(([permission, permissionLabel]) => (
                            <PermissionInput key={permission} name={permission} label={permissionLabel} />
                        ))}
                    </div>
                </React.Fragment>
            ))}
        </>
    );
};

export default PermissionInputList;
